import { styled } from "styled-components";

import { colors, Text } from "@vericus/cadmus-ui";

interface ClickableSubcategoryProps {
  isActive?: boolean;
  name: string;
  onClick: VoidFunction;
}

export const ClickableSubcategory = ({
  isActive,
  name,
  onClick,
}: ClickableSubcategoryProps) => {
  return (
    <RibbonButton
      isActive={isActive}
      onClick={onClick}
      title={name}
      aria-current={isActive === true ? "true" : "false"}
    >
      <SubcategoryText isActive={isActive} kind="bodyMd" as="div">
        {name}
      </SubcategoryText>
    </RibbonButton>
  );
};

const RibbonButton = styled.button<{ isActive?: boolean }>`
  border: 0;
  margin: 0;
  background: none;
  background-color: ${(p) => (p.isActive ? colors.blue500 : "none")};
  height: 36px;
  width: 100%;
  border-radius: 0px 100px 100px 0px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.1s ease-out;
  padding-right: 6px;

  &:hover {
    background-color: ${(p) => (p.isActive ? colors.blue500 : colors.grey50)};

    &:before {
      display: block;
      background-color: ${(p) => (p.isActive ? colors.blue500 : colors.grey50)};
      position: absolute;
      content: "";
      width: 100%;
      height: 36px;
      left: -100%;
    }
  }

  &:before {
    display: block;
    background-color: ${(p) => (p.isActive ? colors.blue500 : "none")};
    transition: background-color 0.1s ease-out;
    position: absolute;
    content: "";
    width: 100%;
    height: 36px;
    left: -100%;
  }

  &:focus {
    outline: none;
    ${(p) => p.theme.focusInset};
  }
`;

const SubcategoryText = styled(Text)<{ isActive?: boolean; fontSize?: number }>`
  color: ${(p) => (p.isActive ? colors.white100 : colors.black200)};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
